import SvgIcon from '@mui/material/SvgIcon';

export default function KeyboardArrowDownIcon(props) {
  return (
    <SvgIcon {...props}>
      <path fill="currentColor" d="M17.9953 8.68907C17.9953 8.83907 17.9453 8.99063 17.8453 9.11719L12.5187 15.7391C12.389 15.9 12.1937 15.9938 11.9859 15.9938C11.7797 15.9938 11.5828 15.9 11.4547 15.7391L6.15623 9.14532C5.92029 8.85157 5.96717 8.42188 6.26092 8.18594C6.55467 7.95 6.98436 7.99688 7.22029 8.29063L11.9875 14.2219L16.7812 8.26094C17.0172 7.96719 17.4469 7.92032 17.7406 8.15625C17.9078 8.29219 17.9953 8.48907 17.9953 8.68907Z" />
    </SvgIcon>
  );
}
